import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Errors, LeaderboardService } from '../../../core';

@Component({
  selector: 'app-leaderboard-sales-tab',
  templateUrl: './leaderboard-sales-tab.component.html',
  styleUrls: ['./leaderboard-sales-tab.component.scss']
})
export class LeaderboardSalesTabComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() userData: any;
  @Input() isActive: boolean = false;

  @ViewChild('rankTemplate') rankTemplate!: TemplateRef<any>;
  @ViewChild('participantTemplate') participantTemplate!: TemplateRef<any>;
  @ViewChild('bookingsTemplate') bookingsTemplate!: TemplateRef<any>;
  @ViewChild('earningsTemplate') earningsTemplate!: TemplateRef<any>;

  errors: Errors = { errors: {} };
  generalLeaderboardData: any;
  selectedObject: any;
  salesLeaderboardData: any;
  salesLeaderboardColumns: any[] = [];
  salesLeaderboardPage: number = 1;
  salesLeaderboardItemsPerPage: number = 5;
  currentSalesLeaderboardItem: any;

  isLoading: boolean = false;
  private hasLoaded: boolean = false;

  constructor(private leaderboardService: LeaderboardService) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isActive'] && this.isActive && !this.hasLoaded) {
      this.hasLoaded = true;
      this.getGeneralLeaderboards();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => { this.initializeSalesLeaderboardTable(); });
  }

  getGeneralLeaderboards() {
    const userType = localStorage.getItem('selectedRole') === 'manager' ? 'LEADER' : 'SELLER';
    this.leaderboardService.getSalesLeaderBoardList(this.userData.company.id, userType).subscribe((data) => {
      if (data.length) {
        this.generalLeaderboardData = data;
        this.selectedObject = data[0];
        this.onChangeSalesLeaderboard(data[0]);
      }
    }, (err) => {
      this.errors = err;
    });
  }

  onChangeSalesLeaderboard(item: any) {
    this.currentSalesLeaderboardItem = item;
    this.salesLeaderboardPage = 1;
    this.fetchSalesLeaderboardData(0);
  }

  fetchSalesLeaderboardData(pageIndex: number) {
    if (!this.currentSalesLeaderboardItem) { return; }
    const req = this.userData.company.id + '?challengeId=' + this.currentSalesLeaderboardItem.challengeId + '&page=' + pageIndex + '&size=5';
    this.isLoading = true;
    this.leaderboardService.getSalesLeaderboardData(req).subscribe((response) => {
      this.isLoading = false;
      this.salesLeaderboardData = {
        salesLeaderBoard: 'SLB',
        data: response,
        chalID: this.currentSalesLeaderboardItem.challengeId
      };
    }, (err) => {
      this.isLoading = false;
      this.errors = err;
    });
  }

  initializeSalesLeaderboardTable() {
    const rankCol: any = { field: 'rank', header: 'Rank', align: 'center', isBold: true };
    const participantCol: any = { field: 'participant', header: 'Participant' };
    const bookingsCol: any = { field: 'bookingsSoldOrClaimed', header: 'Bookings', align: 'right', isBold: true, prefix: '$' };
    const earningsCol: any = { field: 'pointsEarned', header: 'Earnings', align: 'right', highlight: 'green', isBold: true, suffix: ' pts', numberFormat: true };

    if (this.rankTemplate) { rankCol.cellTemplate = this.rankTemplate; }
    if (this.participantTemplate) { participantCol.cellTemplate = this.participantTemplate; }
    if (this.bookingsTemplate) { bookingsCol.cellTemplate = this.bookingsTemplate; }
    if (this.earningsTemplate) { earningsCol.cellTemplate = this.earningsTemplate; }

    this.salesLeaderboardColumns = [
      rankCol,
      { field: 'country', header: 'Country' },
      participantCol,
      bookingsCol,
      earningsCol
    ];
  }

  onSalesLeaderboardPageChange(newPage: number) {
    this.salesLeaderboardPage = newPage;
    this.fetchSalesLeaderboardData(newPage - 1);
  }

  splitData(value: any): string {
    const parseValue = parseFloat(value);
    if (isNaN(parseValue)) { return '0'; }
    return parseValue.toLocaleString('en-US');
  }
}
